<template>
  <div id=welcome>

    <div id="welcome-graphic">
      <WelcomeGraphic />
    </div>
    <h1>{{ title }}</h1>
    <bruger-info
      v-if="this.showBrugerInfo"
      :editingUser="editingUser"
      :setEditingUser="setEditingUser"
    />
    <div class="logos-container">
      <a
        href="http://www.septima.dk"
        target="_blank"
        class="septima-logo"
      >
        <SeptimaLogo :height="30" />
      </a><a
        href="https://www.herning.dk"
        target="_blank"
        class="septima-logo"
      >
        <HerningLogo :height="45" /></a>
    </div>
  </div>
</template>

<script>
import WelcomeGraphic from './WelcomeGraphic.vue';
import BrugerInfo from './BrugerInfo.vue';
import SeptimaLogo from '@/components/Icons/SeptimaLogo.vue';
import HerningLogo from '@/components/Icons/HerningLogo.vue';
export default {
  name: 'welcome',
  components: { WelcomeGraphic, BrugerInfo, SeptimaLogo, HerningLogo },
  props: {
    title: String,
    showBrugerInfo: { type: Boolean, value: true },
    editingUser: String,
    setEditingUser: Function,
  },
};
</script>

<style lang="scss">
#welcome {
  display: flex;
  flex-direction: column;
  background-color: #0f1c70;
  width: 470px;
  min-height: 100vh;
  color: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;

  h1 {
    position: absolute;
    top: 52px;
    width: 100%;
    font-size: 24px;
    font-weight: 700;
    line-height: 140%;
    text-align: center;
    margin: 0;
    padding: 10px;
    span {
      display: block;
    }
  }

  @keyframes floating {
    from {
      transform: rotate(0deg) translateX(3px) rotate(0deg);
    }
    to {
      transform: rotate(360deg) translateX(3px) rotate(-360deg);
    }
  }
  @keyframes floating2 {
    from {
      transform: rotate(360deg) translateX(8px) rotate(-360deg);
    }
    to {
      transform: rotate(0deg) translateX(8px) rotate(0deg);
    }
  }

  #Oval1,
  #Oval2,
  #Oval3 {
    animation: floating 8s linear infinite;
  }
  #Oval4,
  #Oval5,
  #Oval6,
  #Oval7 {
    animation: floating2 10s linear infinite;
  }
  .logos-container {
    display: flex;
    justify-content: space-around;
    padding: 20px;
    margin-top: auto;
  }
  .septima-logo {
    opacity: 0.5;
    align-self: center;
  }
}
@media only screen and (max-width: $tablet-landscape-max-width),
  screen and (max-height: 800px) {
  #welcome {
    width: 320px;
    h1 {
      top: 30px;
    }
  }
}

@media only screen and (max-width: $tablet-max-width) {
  #welcome {
    width: 100%;
    position: static;
    min-height: 0;
    h1 {
      top: 0;
      margin: 40px 0 20px 0;
      span {
        display: inline;
      }
    }
    .logos-container {
      margin-top: 180px;
      justify-content: space-between;
      padding: 20px 30px;
    }
  }

  // kun trigget i IE11:
  _:-ms-fullscreen,
  :root #welcome {
    .logos-container {
      margin: 0;
    }
  }
}

@media only screen and (max-width: $mobile-max-width) {
  #welcome {
    h1 {
      margin: 20px 0 10px 0;
      padding: 0 20px;
    }
    .logos-container {
      margin-top: 80px;
    }
  }

  // kun trigget i IE11:
  _:-ms-fullscreen,
  :root #welcome {
    .logos-container {
      margin: 0;
    }
  }
}
</style>
